exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-menu{height:100%}.el-submenu__title:hover{background-color:#ff5a00;color:#000}.el-submenu__title:hover i{color:#000}.nav-link{padding:0}.el-aside{position:fixed;top:0;padding-left:0;height:100%;min-height:100%}.el-aside>ul{padding-top:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-08a52d92","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Sidebar.vue
// module id = qzvR
// module chunks = 19